export const contactsData = {
    email: 'ilshin714@gmail.com',
    phone: '+12265057233',
    address: 'Ontario, Canada ',
    sheetAPI: 'https://sheetdb.io/api/v1/xh8q7iewc8lm5'
}